import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

function processSubmission(method, data, additionalHeaders = {}) {
    return JsonRPCService.send(getProxiedServiceUrl("rewrite"), method, data, additionalHeaders);
}

export default class MLRewriteService {

    static getJobData(jobNumber, additionalHeaders = {}) {
        return processSubmission('getJobData', [jobNumber], additionalHeaders);
    }

    static retrieveRewrite(policyNumber, additionalHeaders = {}) {
        return processSubmission('retrieveRewrite', [policyNumber], additionalHeaders);
    }

    static saveAndQuote(model, additionalHeaders = {}) {
        return processSubmission('saveAndQuote', [model], additionalHeaders);
    }

    static bind(model, additionalHeaders = {}) {
        return processSubmission('bind', [model], additionalHeaders);
    }

    static withdrawRewriteByJobNumber(jobNumber, additionalHeaders = {}) {
        return processSubmission('withdrawRewriteByJobNumber', [jobNumber], additionalHeaders);
    }

    static computeNewTermExpirationDate(policyNumber, newEffectiveDate, additionalHeaders = {}) {
        return processSubmission('computeNewTermExpirationDate', [policyNumber, newEffectiveDate], additionalHeaders);
    }
}
